import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromUser from './user.reducers';

export interface State {
  profile: fromUser.State;
}

export const reducers: ActionReducerMap<State, any> = {
  profile: fromUser.reducer,
};

export const selectAuthFeatureState = createFeatureSelector<State>('users');
